import {
  Column, useTable, useSortBy, usePagination, useFilters, useGlobalFilter,
} from 'react-table';

import { PaginationProps } from './Pagination';
import { GlobalFilterProps } from './GlobalFilter';

interface SortBy {
  id: string;
  desc: boolean;
}

export const useDataTable = (
  columns: Array<any>,
  data: Array<{[key: string]: string}>,
  isGlobalFilter: any,
  initPageSize: number,
  initPageIndex: number,
  sortBy?: Array<SortBy>,
  globalFilterTxt?: string,
) => {
  const {
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageCount,
    nextPage,
    previousPage,
    state,
    state: { pageIndex, pageSize },
    flatRows,
    setPageSize,
    gotoPage,
    setGlobalFilter,
  } = useTable(
    {
      columns,
      data,
      autoResetPage: false,
      autoResetSortBy: false,
      initialState: {
        hiddenColumns: columns.filter(col => col.show === false).map(col => col.accessor),
        pageSize: initPageSize,
        pageIndex: initPageIndex,
        sortBy: sortBy || [],
        globalFilter: globalFilterTxt,
      },
      disableSortRemove: true
    },
    useFilters, // useFilters!
    useGlobalFilter, // useGlobalFilter!
    useSortBy,
    usePagination,
  );

  const filter: GlobalFilterProps = {
    state,
    setGlobalFilter,
  };

  const pagination: PaginationProps = {
    total: data.length,
    pageCount,
    pageSize,
    pageIndex,
    nextPage,
    canNextPage,
    previousPage,
    canPreviousPage,
    setPageSize,
    gotoPage: (pageNum:number) => gotoPage(pageNum - 1),
  };

  return {
    headerGroups,
    page,
    prepareRow,
    pagination,
    gotoPage,
    filter,
    flatRows
  };
};

export default {
  useDataTable,
};
